import { useDispatch } from "react-redux";
import { _idProofType, _toastVariants } from "../../utils/Constant";
import { showMessage } from "../../utils/toast/globalToast";
import {
  validateImageFileType,
  getFileUrl,
  uploadFile,
  validateDocumentFileType,
} from "../../utils/helper/appHelpers";
import { aboutCompanyValidation } from "./validations";
import PlaceSearch from "../location/PlaceSearch";


const AboutCompany = ({ formik, setSideBarState, isDisabled }) => {

  const handleNext = async (e) => {
    if (isDisabled) return; 
    try {
      e.preventDefault();
      handleSubmit();
      // ✅ validate form values
      await aboutCompanyValidation.validate(formik.values, {
        abortEarly: false,
      });

      // ✅ if validation passes → go to next step
      setSideBarState((prev) => ({
        ...prev,
        aboutCompany: { isCompleted: true, isActive: false },
        aboutYou: { isCompleted: false, isActive: true },
        setPassword: { isCompleted: false, isActive: false },
      }));
    } catch (error) {
      if (error.inner) {
        // Map Yup validation errors into Formik errors
        const formikErrors = error.inner.reduce((acc, err) => {
          if (err.path) {
            acc[err.path] = err.message;
          }
          return acc;
        }, {});

        // ✅ Set Formik's errors
        formik.setErrors(formikErrors);
      }
    }
  };

  const handleAttachment = async (e) => {
     if (isDisabled) return;
    try {
      const [file] = e.target.files;
      if (!file) return;
      // File size check (2 MB max)
      const maxSize = 2 * 1024 * 1024;
      if (file.size > maxSize) {
        return showMessage({
          variant: _toastVariants.Error,
          message: "File size should not exceed 2 MB",
        });
      }
      const isValid = validateImageFileType(file.type);
      if (!isValid) {
        return showMessage({
          variant: _toastVariants.Error,
          message: "Unsupported file type",
        });
      }
      setFieldValue("businessLogo", file);
    } catch (error) { }
  };

  const { values, touched, errors, setFieldValue, handleSubmit } = formik;

  return (
    <div className="col-md-8 px-5">
      <form onSubmit={(e) => handleNext(e)}>
        <div className="row mt-5 px-5">
          <div className="col-md-12">
            <div className="about-section">
              <h4>Tell us about your company</h4>
              <p>Signup - company</p>
            </div>
          </div>
          <div className="col-md-12">
            <label for="" class="label-input mb-1">
              Upload/ browse shop photo OR logo
            </label>{" "}
            <br />
            <div style={{ width: "35%" }}>
              <input
                disabled={isDisabled}   
                type="file"
                id="formFileMultiple"
                accept="*/*"
                className="d-none"
                onChange={(e) => handleAttachment(e)}
              />
              <label
                htmlFor="formFileMultiple"
               className={`btn btn-outline-secondary upload-btn w-100 ${isDisabled ? "disabled" : ""}`}
              >
                +
              </label>
            </div>
            {values.businessLogo && (
              <div className="row align-items-center">
                <div className="col-md-2">
                  <div className="uploaddiv">
                    <img
                      src={getFileUrl(values.businessLogo)}
                      className="uploadimages"
                      alt=""
                    />
                    {!isDisabled && (
                       <div onClick={() => setFieldValue("businessLogo", null)}>
                      <img
                        src="images/close.svg"
                        className="closeimg"
                        alt="business logo"
                      />
                    </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-md-12 mt-3">
            <label htmlFor="businessName" className="label-input mb-1">
              Business name<span className="text-danger">*</span>
            </label>{" "}
            <br />
            <input
              disabled={isDisabled}
              type="text"
              id="businessName"
              className="form-control login-input"
              placeholder="Enter Business name"
              onChange={(e) => setFieldValue("businessName", e.target.value)}
              value={values.businessName}
            />
            {touched.businessName && errors.businessName && (
              <div className="text-danger">{errors.businessName}</div>
            )}
          </div>
          <div className="col-md-12 mt-3">
            <label htmlFor="businessType" className="label-input mb-1">
              Business Type<span className="text-danger">*</span>
            </label>{" "}
            <br />
            <select
            disabled={isDisabled}
              id="businessType"
              className="form-control login-input"
              onChange={(e) => setFieldValue("businessType", e.target.value)}
              value={values.businessType}
            >
              <option value="store">Store</option>
              <option value="van">Van</option>
            </select>
            {errors.businessType && (
              <div className="text-danger">{errors.businessType}</div>
            )}
          </div>

          {values.businessType === "store" && (
            <div className="col-md-12 mt-3">
              <label htmlFor="" className="label-input mb-1">
                Business location{<span className="text-danger">*</span>}
              </label>{" "}
              <br />
              <PlaceSearch
                disabled={isDisabled}
                placeholder="Enter Address name"
                type="address"
                defaultValue={values.businessLocation?.address}
                // error={Boolean(touched.businessLocation?.address && errors.businessLocation?.address)}
                // helperText={touched.businessLocation?.address && errors.businessLocation?.address}
                onselect={(text) => !isDisabled && setFieldValue("businessLocation", text)}
              />
              {touched.businessLocation?.address && errors.businessLocation?.address && (
                <div className="text-danger">{errors.businessLocation?.address}</div>
              )}
            </div>
          )}

          <div className="col-md-12 mt-4">
            <label htmlFor="" className="label-input f-18 mb-0">
              Documents
            </label>{" "}
            <br />
            <div className="d-flex align-items-center justify-content-between">
              <label htmlFor="" className="label-input mb-1">
                Registration Certificate{<span className="text-danger">*</span>}
              </label>{" "}
              <br />
              <i
                data-bs-toggle="tooltip"
                className="fa fa-info-circle"
                style={{ color: "#C1C9C9" }}
                aria-hidden="true"
                title="Registration Certificate"
              ></i>
            </div>
            {values.registrationDocuments.map((doc, docIndex) => (
              <div
                key={docIndex}
                className="card mb-2 shadow-sm rounded-3 position-relative"
              >
                <div className="card-body">
                  <div className="row aic">
                    {/* Type */}
                    <div className="col-md-4">
                      <label className="label-input">Type</label>
                      <input
                        disabled={isDisabled}
                        type="text"
                        className="form-control login-input"
                        placeholder="Certificate type"
                        onChange={(e) => {
                        if (isDisabled) return;
                        const newDocs = [...values.registrationDocuments];
                        newDocs[docIndex].name = e.target.value;
                        setFieldValue("registrationDocuments", newDocs);
                        }}
                        value={doc.name}
                      />
                    </div>

                    {/* Expiry */}
                    <div className="col-md-4">
                      <label className="label-input">Expiry</label>
                      <input
                       disabled={isDisabled}
                        type="date"
                        className="form-control login-input"
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                        if (isDisabled) return;
                        const newDocs = [...values.registrationDocuments];
                        newDocs[docIndex].expiryDate = e.target.value;
                        setFieldValue("registrationDocuments", newDocs);
                        }}
                        value={doc.expiryDate}
                      />
                    </div>

                    {/* Upload */}
                    <div className="col-md-4">
                      <label className="label-input">Document</label>
                      <input
                        disabled={isDisabled}
                        type="file"
                        id={`uploadDoc-${docIndex}`}
                        className="d-none form-control"
                        onChange={async (e) => {
                          if (isDisabled) return;
                          const [file] = e.target.files;
                          if (!file) return;
                          // File size check (2 MB max)
                          const maxSize = 2 * 1024 * 1024;
                          if (file.size > maxSize) {
                            return showMessage({
                              variant: _toastVariants.Error,
                              message: "File size should not exceed 2 MB",
                            });
                          }
                          const isValid = validateDocumentFileType(file.type);
                          if (!isValid) {
                            return showMessage({
                              variant: _toastVariants.Error,
                              message: "Unsupported file type",
                            });
                          }

                          const newDocs = [...values.registrationDocuments];
                          newDocs[docIndex].attachments = [
                            ...newDocs[docIndex].attachments,
                            file,
                          ];
                          setFieldValue("registrationDocuments", newDocs);
                        }}
                      />
                      <label
                        htmlFor={`uploadDoc-${docIndex}`}
                        className={`form-control login-input mb-0 ${isDisabled ? "disabled" : ""}`}
                        style={{ cursor: "pointer" }}
                      >
                        + Add
                      </label>
                    </div>

                    <div className="col-md-12">
                      {/* Preview */}
                      {doc.attachments.length > 0 && (
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                flexWrap: "wrap",
                              }}
                            >
                              {doc.attachments.map((item, index) => (
                                <div key={index} className="uploaddiv">
                                  <img
                                    src={getFileUrl(item)}
                                    className="uploadimages"
                                    alt=""
                                  />
                                  <div
                                    onClick={() => {
                                      const newDocs = [
                                        ...values.registrationDocuments,
                                      ];
                                      newDocs[docIndex].attachments = newDocs[
                                        docIndex
                                      ].attachments.filter((_, i) => i !== index);
                                      setFieldValue(
                                        "registrationDocuments",
                                        newDocs
                                      );
                                    }}
                                  >
                                    <img
                                      src="images/close.svg"
                                      className="closeimg"
                                      alt="remove"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Cross Button */}
                    <div>
                      {!isDisabled && docIndex !== 0 && (
                        <span
                          className="badge doc-c-btn"
                          onClick={() => {
                            const newDocs = values.registrationDocuments.filter(
                              (_, i) => i !== docIndex
                            );
                            setFieldValue("registrationDocuments", newDocs);
                          }}
                        >
                          X
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="row aic justify-content-between mt-3">
              <div className="col-md-7">
                {touched.registrationDocuments && errors.registrationDocuments && (
                  <div className="text-danger mt-0">
                    {errors.registrationDocuments}
                  </div>
                )}
              </div>
              <div className="col-md-5 text-right">
                {values.registrationDocuments.length > 0 && (
                  <button
                    disabled={isDisabled}
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      setFieldValue("registrationDocuments", [
                        ...values.registrationDocuments,
                        { name: "", expiryDate: "", attachments: [] },
                      ])
                    }
                  >
                    + Add More Document
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-12 mt-4">
            <div className="d-flex align-items-center justify-content-between">
              <label htmlFor="" className="label-input mb-1">
                ID proof eg: Driving Licence/ Passport /Green Card etc.
                {<span className="text-danger">*</span>}
              </label>{" "}
              <br />
              <i
                data-bs-toggle="tooltip"
                className="fa fa-info-circle"
                style={{ color: "#C1C9C9" }}
                aria-hidden="true"
                title="ID Proof Doc"
              ></i>
            </div>
            {values.idProof.map((doc, docIndex) => (
              <div
                key={docIndex}
                className="card shadow-sm rounded-3 position-relative"
              >
                <div className="card-body">
                  <div className="row aic">
                    {/* Type */}
                    <div className="col-md-4">
                      <label className="label-input">Type</label>
                      <select
                        disabled={isDisabled}
                        type="text"
                        className="form-control login-input"
                        placeholder="Certificate type"
                        onChange={(e) => {
                          const newDocs = [...values.idProof];
                          newDocs[docIndex].name = e.target.value;
                          setFieldValue("idProof", newDocs);
                        }}
                        value={doc.name}
                      >
                        <option value="" selected disabled>
                          Certificate type
                        </option>
                        {Object.entries(_idProofType).map(([key, value]) => (
                          <option key={key} value={key}>{value}</option>
                        ))}
                      </select>
                    </div>

                    {/* Expiry */}
                    <div className="col-md-4">
                      <label className="label-input">Expiry</label>
                      <input
                        disabled={isDisabled}
                        type="date"
                        className="form-control login-input"
                        min={new Date().toISOString().split("T")[0]}
                        onChange={(e) => {
                          const newDocs = [...values.idProof];
                          newDocs[docIndex].expiryDate = e.target.value;
                          setFieldValue("idProof", newDocs);
                        }}
                        value={doc.expiryDate}
                      />
                    </div>

                    {/* Upload */}
                    <div className="col-md-4">
                      <label className="label-input">Document</label>
                      <input
                        disabled={isDisabled}
                        type="file"
                        id={`uploadIdProof-${docIndex}`}
                        className="d-none form-control"
                        onChange={async (e) => {
                          const [file] = e.target.files;
                          if (!file) return;
                          // File size check (2 MB max)
                          const maxSize = 2 * 1024 * 1024;
                          if (file.size > maxSize) {
                            return showMessage({
                              variant: _toastVariants.Error,
                              message: "File size should not exceed 2 MB",
                            });
                          }
                          const isValid = validateDocumentFileType(file.type);
                          if (!isValid) {
                            return showMessage({
                              variant: _toastVariants.Error,
                              message: "Unsupported file type",
                            });
                          }

                          const newDocs = [...values.idProof];
                          newDocs[docIndex].attachments = [
                            ...newDocs[docIndex].attachments,
                            file,
                          ];
                          setFieldValue("idProof", newDocs);
                        }}
                      />
                      <label
                        htmlFor={`uploadIdProof-${docIndex}`}
                        className="form-control login-input mb-0"
                        style={{ cursor: "pointer" }}
                      >
                        + Add
                      </label>
                    </div>

                    {/* Preview */}
                    <div className="col-md-12">
                      {doc.attachments.length > 0 && (
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                flexWrap: "wrap",
                              }}
                            >
                              {doc.attachments.map((item, index) => (
                                <div key={index} className="uploaddiv">
                                  <img
                                    src={getFileUrl(item)}
                                    className="uploadimages"
                                    alt=""
                                  />
                                  <div
                                    onClick={() => {
                                      const newDocs = [...values.idProof];
                                      newDocs[docIndex].attachments = newDocs[
                                        docIndex
                                      ].attachments.filter((_, i) => i !== index);
                                      setFieldValue("idProof", newDocs);
                                    }}
                                  >
                                    <img
                                      src="images/close.svg"
                                      className="closeimg"
                                      alt="remove"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Cross Button */}
                    {!isDisabled && docIndex !== 0 && (
                      <span
                        className="badge doc-c-btn"
                        onClick={() => {
                          const newDocs = values.idProof.filter(
                            (_, i) => i !== docIndex
                          );
                          setFieldValue("idProof", newDocs);
                        }}
                      >
                        X
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
            <div className="row aic justify-content-between">
              <div className="col-md-7">
                {touched.idProof && errors.idProof && (
                  <div className="text-danger mt-0">{errors.idProof}</div>
                )}
              </div>
              <div className="col-md-5 text-right">
                {values.idProof.length > 0 && (
                  <button
                    disabled={isDisabled}
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      setFieldValue("idProof", [
                        ...values.idProof,
                        { name: "", expiryDate: "", attachments: [] },
                      ])
                    }
                  >
                    + Add More Document
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="col-md-12 mb-5 mt-5">
            <button disabled={isDisabled} type="submit" className="btn btn-dark login-btn">
              Next
            </button>
          </div>

          <div className="col-md-12 pb-4">
            <p className="text-center foot-text">
              Existing user?{" "}
              <a href="/login" style={{ textDecoration: "underline" }}>
                Sign In
              </a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AboutCompany;
